RivalIQ.apps.LandscapeSettings.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.DeleteCustomBrandingModal = Marionette.ItemView.extend({
        ui: {
            modal: '.modal',
            save: '.x-yes'
        },
        events: {
            'click .x-yes': 'onYesClicked'
        },
        template: '#deleteCustomBrandingModalTemplate',
        onYesClicked: function () {
            const me = this;

            me.ui.save.button('loading');

            me.model.destroy().done(function () {
                me.ui.modal.modal('hide');
            });
        }
    });
});
